module.exports = __webpack_public_path__ + "static/media/welder-icon.7736b5d6.png";